import { useLastVisitedTab } from "../contexts/DeviceContext";

export default function useCurrentConversationId() {
  const { lastVisitedTab: lastTab } = useLastVisitedTab();
  return lastTab?.tab === "conversation" && lastTab?.id ? lastTab.id : null;
}
